import EditableLabel from '../../../../../../components/EditableLabel/EditableLabel'
import React, { useContext } from 'react'
import styles from './RGPDField.module.css'
import { BuilderContext } from '../../../store/store.Builder'
import EditableDescription from '../../../../../../components/EditableDescription/EditableDescription'
const RGPDField = ({ field }) => {
  const builderContext = useContext(BuilderContext)

  return <div></div>
}
export default RGPDField
